import { Cluster } from '@cast/types';

import { useDefaultPhase2SuccessNavigation } from 'hooks/dialogs/cluster/_hooks/useDefaultPhase2SuccessNavigation';
import { FeatureName, FeatureSelection } from 'hooks/dialogs/cluster/types';

import { AssignCredentialsDialogContentV2 } from './_components/AssignCredentialsDialogContentV2';

type Props = {
  cluster: Cluster;
  destroy: () => void;
  promotedFeature?: FeatureName;
  shouldNavigateOnSuccess?: boolean;
  onSuccess?: (features: FeatureSelection) => void;
};

export const AssignCredentialsDialogV2 = ({
  shouldNavigateOnSuccess = true,
  onSuccess,
  ...props
}: Props) => {
  const onSuccessNavigation = useDefaultPhase2SuccessNavigation();

  return (
    <AssignCredentialsDialogContentV2
      {...props}
      onSuccess={(features) => {
        onSuccess?.(features);

        if (shouldNavigateOnSuccess) {
          onSuccessNavigation(props.cluster, features);
        }
      }}
    />
  );
};
